var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeopleIconTool(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.457,
    height: 19.911,
    viewBox: "0 0 15.457 19.911",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M893.356 233.217l-2.7 2.7-2.7-2.7h-4.786v5.2h15.457v-5.2z",
    transform: "translate(-235 -206.463) translate(-648.167 -12.04)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.633 224.618v3.45h-2.115v-3.45h-4.043l1.285 6h7.423l1.285-6z",
    transform: "translate(-235 -206.463) translate(-648.167 -12.04)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.184 218.5h-9.053l-.284 1.833-1.471-.228.8 3.726h10.459l2.991-5.332z",
    transform: "translate(-235 -206.463) translate(-648.167 -12.04)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleIconTool);
export default __webpack_public_path__ + "static/media/people-icon-tool.58700ca9.svg";
export { ForwardRef as ReactComponent };